const nav = document.getElementById('nav');
const navButton = document.getElementById('nav-button');

if (navButton && nav) {
  navButton.addEventListener('click', () => {
    navButton.classList.toggle('is-opened');
    nav.classList.toggle('is-opened');
  });
}

// fixed viewport 320px
const viewport = document.querySelector('meta[name="viewport"]');
function switchViewport() {
  const value =
    window.outerWidth > 320
      ? 'width=device-width,initial-scale=1'
      : 'width=320';
  if (viewport && viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}
addEventListener('resize', switchViewport, false);
switchViewport();
